import React /*, { useEffect, useMemo, useState }*/ from "react";
// import { dataSource } from "../../../services/dataSource";
// import { LANG_V2, REP_V2 } from "../../../shared/Data/typeDirs";
// import { ReportV2 } from "../../../shared/Objects/newReportObjects/report_v2";
// import { NewControlManager } from "../../newControlManager";
// import { useAppContainerContext } from "../appContainer/context";
import { TestNotifications } from "./testNotifications";


export function TestPage(props) {
  // const {setTitle, setMenuOptions} = useAppContainerContext()
  // const [report, setReport] = useState(false)
  // const [imageMap, setImageMap] = useState(false)

  // async function init(){
    
  //   let _r = await dataSource('remDb')[REP_V2].get({ _id:"6733da4db8aa0557405332e7"})
  //   // let _r = await dataSource('remDb')[REP_V2].get({ _id:"66ecfc78fd1f70f93fe2c6b5"})
  //   _r = new ReportV2(_r)
  //   let language = await dataSource('remDb')[LANG_V2].getTyped({ _id: _r[LANG_V2] })
  //   console.log('got init stuff', _r, language)
  //   _r[LANG_V2] = language
  //   const _imageMap = await _r.getImageMap()
  //   console.log('got imagemap', _imageMap)
  //   setImageMap(_imageMap)
  //   setReport(_r)
  //   setTitle(_r.name)
  //   setMenuOptions([])
  // }

  // useEffect( () => {
  //   init()
  // }, [])

  // // function getImageMap(){

  // // }
  // const reportMetadata = useMemo(()=>{
  //   let {report_blocks, report_top_blocks, preamble_blocks, language_v2, ...metadata} = report
  //   return metadata
  // }, [report])

  // const {
  //   schemas, content, source
  // } = useMemo(()=>({
  //   content: report && report.getContents(report[LANG_V2].source),
  //   schemas: report && report.getSchemas(), 
  //   source: report && {...report[LANG_V2].source, imageMap}
  // }), [report])

  // return report?(
  //   <div className="con-man-wrapper">

  //     <NewControlManager
  //       registerGetData={(...a)=>console.log('registerGetData', a)}
  //       onSubmit={(...a)=>console.log('onSubmit', a)}
  //       content={content}
  //       schemas={schemas}
  //       source={source}
  //       objectMetadata={reportMetadata}
  //       headerOptions={{wrapperType: REP_V2}}
  //     />
  //   </div>
  // ):[]
  return (
    <TestNotifications />
  )
}